export const MULTI_OFFERINGS_MIN_WIDTH = 740;
export const MOBILE_MULTI_OFFERINGS_MIN_WIDTH = 260;
